//import './sass/style.scss'; //using dart sass not webpack to compile sass - check package.json

//if global/window jquery needs to be exposed
//global.$ = $;

import $ from 'jquery';

//vendor files if NPM package isn't available
//import './vendor/slick';

//our files
import App from './app';
import Search from './search';
import FormSplit from './form-split';

$(() => {
  // FormSplit first and on its own, so an error thrown by any other
  // module's init() below can never stop this one from running.
  FormSplit.init();

  // Initialize global modules
  App.init();
  Search.init();
});
